export default __webpack_public_path__ + "static/code-of-conduct-edff1d1433e47f9d114e54fb3d2bb5ca.svg";